/*eslint-disable*/
import api from '../'

class TariffsApi {
    static list() {
        return api.axios.get('/tariffs')
            .then(response => response.data);
    }

    static update(id, params = {}) {
        if (id === undefined || id === null) {
            throw new Error('TariffsApi.update: "id" is required');
        }
        return api.axios.post(`/tariffs/${id}`, params)
            .then(response => response.data);
    }

    static changeTariff(params = {}) {
        return api.axios.post('/update-school-tariff-change-request', params)
            .then(response => response.data);
    }

    static activateTariffTrial(params = {}) {
        return api.axios.post('/tariff-trial', params)
            .then(response => response.data);
    }

    static activatePaidNow() {
        return api.axios.post('/tariffs/activate-paid-now')
            .then(response => response.data);
    }

    static updatePlayTime(params = {}) {
        return api.axios.put('/tariffs/update-play-time', params)
            .then(response => response.data);
    }
}

export default TariffsApi;